import { Button, IconStar } from "@veneer/core";
import { POST_FAVOURITES } from "../../../../services";
import { apiPost } from "../../../../services/service";

function Favourite(props: any) {
  const handleFev = async (
    caseId: string,
    state: string,
    tableid: string,
    e: any
  ) => {
    if (!props?.caseId) {
      return false;
    }
    if (props?.setIsChecked) {
      props.setIsChecked();
    }
    try {
      props.loader();
      let payload = {
        key: tableid,
        state: `${state}`, //"ON",//OFF
        contactid: "85680c15-7814-e711-80fc-5065f38ad971",
        id: `${caseId};`,
      };
      
      const fev = await apiPost(POST_FAVOURITES, payload);
      if (fev?.data) {
        props.pageload();
      } else {
        console.error("No data found in response");
      }
    } catch (error) {
      return false;
    }
  };
  return (
    <>
      {props.favourite === "true" ? (
        <Button
          onClick={(e) => handleFev(props?.caseId, "OFF", props?.tableid, e)}
          appearance="ghost"
          leadingIcon={<IconStar filled size={40} />}
        />
      ) : (
        <Button
          onClick={(e) => handleFev(props?.caseId, "ON", props.tableid, e)}
          appearance="ghost"
          leadingIcon={<IconStar size={40} />}
        />
      )}
    </>
  );
}

export default Favourite;
